import React, { FC } from "react";
import { Stack, Typography, TypographyProps } from "@mui/material";
import styled from "@emotion/styled";



export const NoDataFound: FC<TypographyProps> = (props) => (
    <LoadingContainer alignItems="center">
        <Typography {...props}/>
    </LoadingContainer>
)

const LoadingContainer = styled(Stack)`
    padding: 20px 10px;
    .MuiTypography-root {
        color: #ccc !important;
    }
`;
